import Landing from "./Landing";
import "./Landing.css";

export default Landing